import {
  getTenantListApi,
  createTenantApi,
  getAllUsersApi,
  updateUserProfileApi,
  createUserApi,
  getUsersForTenantApi,
  getTenantLogoUrlApi,
  getProfilesApi,
} from 'src/api/tenant';

import {
  TENANT_LIST,
  CREATE_TENANT,
  ALL_USERS,
  UPDATE_PROFILE,
  CREATE_USER,
  GET_TENANT_LOGO_URL,
  GET_PROFILES,
} from 'src/redux/Actions/Type';

export const getTenantList = () => (dispatch) =>
  getTenantListApi().then((data) => {
    dispatch({
      type: TENANT_LIST,
      payload: data,
    });
  });

export const createTenant = (userData) => (dispatch) =>
  createTenantApi(userData).then((data) => {
    dispatch({
      type: CREATE_TENANT,
      payload: data,
    });
  });

export const getTenantUsers = (tenantId) => (dispatch) =>
  getUsersForTenantApi(tenantId).then((data) => {
    dispatch({
      type: ALL_USERS,
      payload: data,
    });
  });

export const getAllUsers = () => (dispatch) =>
  getAllUsersApi().then((data) => {
    dispatch({
      type: ALL_USERS,
      payload: data,
    });
  });

export const updateProfile = (userData) => (dispatch) =>
  updateUserProfileApi(userData).then((data) => {
    dispatch({
      type: UPDATE_PROFILE,
      payload: data,
    });
  });

export const createUser = (userData) => (dispatch) =>
  createUserApi(userData).then((data) => {
    dispatch({
      type: CREATE_USER,
      payload: data,
    });
  });

export const getTenantLogoUrl = (tenantId) => (dispatch) =>
  getTenantLogoUrlApi(tenantId).then((data) => {
    dispatch({
      type: GET_TENANT_LOGO_URL,
      payload: data,
    });
  });

export const getProfiles = (tenantId, searchTerm) => (dispatch) =>
  getProfilesApi(tenantId, searchTerm).then((data) => {
    dispatch({
      type: GET_PROFILES,
      payload: data,
    });
    return Promise.resolve(data);
  });
